import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import { Theme } from '../../config/theme.js';

export default class ArticleSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        visible: true,
      });
    }, 100);
  }

  render() {
    let imageSource = '';
    if(this.props.post.thumbnail_src) {
      imageSource = this.props.post.thumbnail_src ? this.props.post.thumbnail_src : '/assets/article_summary_image.png';
    } else {
      imageSource = this.props.post.image_src ? this.props.post.image_src : '/assets/article_summary_image.png';
    }


    return (
      <Link className={css(styles.container, this.state.visible ? styles.visible : false)} to={{
          pathname: `/${this.props.post.content_type}/${this.props.post.slug}`,
          state: {
            post: this.props.post
          }
        }}>
        <div className={css(styles.wrapper)}>
          <div className={css(styles.image_container)}>
            <img className={css(styles.image)} src={imageSource} alt={this.props.post.title} />
          </div>
          <div className={css(styles.vibe) + ' vibe'}>{this.props.post.vibe}</div>
          <div className={css(styles.category) + ' category'}>
            {this.props.post.category}
          </div>
          <div className={css(styles.title)}>
            {this.props.post.title}
          </div>
          <div className={css(styles.summary) + ' summary'}>
            {this.props.post.title.length > 59 ? '' : this.props.post.summary}
          </div>
        </div>
      </Link>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: "30%",
    marginRight: "3%",
    marginBottom: "5%",
    height: 366,
    boxSizing: "border-box",
    zIndex: 10,
    opacity: 0,
    transition: 'opacity 480ms ease-in-out',

    [Theme.mobile_query]: {
      width: '90%',
      marginBottom: 30,
      height: 380,
    },

    ":before": {
      display: "block",
      position: "absolute",
      content: "' '",
      top: 5,
      left: 5,
      width: "100%",
      height: 366,
      border: `2px solid ${Theme.yellow}`,
      zIndex: -1,
      transition: 'all 180ms ease-in-out',

      [Theme.mobile_query]: {
        height: 380,
      },
    },
  },
  wrapper: {
    position: "absolute",
    zIndex: 10,
    backgroundColor: Theme.white,
    height: "100%",
    width: "100%",
    boxSizing: 'border-box',
    transition: 'all 180ms ease-in-out',
    cursor: 'pointer',
    ':hover': {
      marginTop: 7,
      marginLeft: 7,
      backgroundColor: Theme.yellow,
    },
    ':hover .category': {
      color: Theme.black,
    },
    ':hover .vibe': {
      opacity: 1,
      color: Theme.yellow,
      ':after': {
        backgroundColor: Theme.yellow,
      },
    },
    ':hover .summary': {
      opacity: 1,
    },
  },
  image_container: {
    position: 'relative',
    width: '100%',
    paddingTop: '71.428571428571429%',
  },
  image: {
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  vibe: {
    position: 'absolute',
    opacity: 0,
    top: 5,
    left: 20,
    display: 'inline-block',
    fontSize: 13,
    color: Theme.yellow,
    textTransform: 'uppercase',
    fontFamily: 'Sailec',
    fontWeight: 900,
    letterSpacing: 2,
    paddingLeft: 0,
    paddingTop: 15,
    transition: 'all 180ms ease-in-out',
    ':after': {
      position: 'absolute',
      display: 'block',
      bottom: -8,
      left: 0,
      content: "' '",
      width: '110%',
      height: 2,
      backgroundColor: Theme.yellow,
      transition: "all 120ms ease-in-out",
    },
  },
  category: {
    fontSize: 10,
    color: Theme.grey,
    textTransform: 'uppercase',
    fontFamily: 'Sailec',
    fontWeight: 900,
    letterSpacing: 2,
    paddingLeft: 15,
    paddingTop: 15,
    transition: 'all 180ms ease-in-out',
  },
  title: {
    fontSize: 15,
    color: Theme.black,
    fontFamily: 'Sailec',
    fontWeight: 'bold',
    paddingLeft: 15,
    paddingTop: 15,
    paddingRight: 5,
    lineHeight: '24px',
  },
  summary: {
    opacity: 0,
    transition: 'all 180ms ease-in-out',
    fontSize: 12,
    color: Theme.black,
    fontFamily: 'Sailec',
    fontWeight: 'normal',
    paddingLeft: 15,
    paddingTop: 5,
    paddingRight: 5,
    lineHeight: '20px',
  },
  visible: {
    opacity: 1,
  }
})



// WEBPACK FOOTER //
// ./src/components/ArticleSummary/index.js